module.exports = __webpack_public_path__ + "static/media/news-channel.84d95356.svg";